import React, { useState } from 'react';
import { Button } from '@telus-uds/components-web';

import PropTypes from 'prop-types';

import { apiHost } from '../../utils/request';
import { getLocale } from '../../misc';
import history from '../../history';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { StatusBarWrapper, BoxWrapper } from './css';
import SendQuoteToCustomer from './sendQuoteToCustomer';

const WlsStatusBar = ({
  isFormTouched,
  onSaveAndExit,
  onSaveAndContinue,
  onProceedClick,
  onBackClick,
  step,
  isLastStep,
  firstStepOverride = undefined,
  shouldHideSubmit,
  orderId,
  hasSendToCustomerOption = false
}) => {
  const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: {
      continueButtonLabel,
      backLabel,
      saveContinueLaterButtonLabel,
      submitButtonLabel
    }
  } = localizedStrings;

  // Send Email to Customer functionality (not required for the time being)
  // const onSaveAndSendToCustomer = () => {
  //   setIsEmailModalVisible(true);
  // };

  const onQuoteDownload = () => {
    // 7X has no worker renderer (see src/__e2e__/pdfAsync.spec.js "7X routes unchanged") so this
    // intentionally stays on the legacy direct-navigation path, not the async requestOrderPdf
    // client used by every other flow — but it must still guard orderId and only leave the form
    // if the PDF tab actually opened, instead of redirecting away unconditionally.
    if (!orderId) return;
    const locale = getLocale();
    const url = `${apiHost}/orders/${orderId}/sevenx-quote-pdf`;
    const pdfWindow = window.open(url);
    if (!pdfWindow) return;
    history.push(`/${locale}/wireless/Wireless_Landing_Page?page=1`);
    window.location.reload();
  };

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          <>
            {step > (firstStepOverride || 1) && (
              <Button variant={{ priority: 'high' }} type="button"
                onClick={onBackClick}>
                {backLabel}
              </Button>
            )}

            {!isLastStep && (
              <Button
                type="button"
                onClick={e => onSaveAndExit(e)}
                variant={{ priority: 'high' }}
                disabled={!isFormTouched}
              >
                {saveContinueLaterButtonLabel}
              </Button>
            )}
            {!shouldHideSubmit && (
              <Button
                type="button"
                onClick={e => onProceedClick(e)}
                variant={{ priority: 'high' }}
              >
                {isLastStep ? submitButtonLabel : continueButtonLabel}
              </Button>
            )}
            {isLastStep && hasSendToCustomerOption && (
              <Button
                type="button"
                onClick={onQuoteDownload}
                variant={{ priority: 'high' }}
              >
                Save PDF to send to customer
              </Button>
            )}
          </>
        </BoxWrapper>
      </div>
      <SendQuoteToCustomer
        orderId={orderId}
        isModalVisible={isEmailModalVisible}
        setIsModalVisible={() => setIsEmailModalVisible(false)}
      />
    </StatusBarWrapper>
  );
};

WlsStatusBar.propTypes = {
  step: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onSaveAndContinue: PropTypes.func.isRequired,
  firstStepOverride: PropTypes.number,
  shouldHideSubmit: PropTypes.bool.isRequired,
  orderId: PropTypes.number.isRequired,
  hasSendToCustomerOption: PropTypes.bool
};

export default WlsStatusBar;
